import { Input, Select } from 'antd';
import { FormikProps, useFormik } from 'formik';
import { phoneTypes, phonesChoice } from 'utils';
import * as Yup from 'yup';

type PhonesTableProps = {
  addPhones: boolean;
  data?: any;
  onClose: () => void;
  onChangeData?: (data) => void;
  parentFormik?: FormikProps<any>;
};
const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const PhonesTable = ({
  addPhones,
  onClose,
  parentFormik,
}: PhonesTableProps) => {
  const phonesData = parentFormik?.values?.phones || [];

  const formSchema = Yup.object().shape({
    type: Yup.string().required(),
    // number: Yup.string()
    //   .matches(phoneRegExp, 'Phone number is not valid')
    //   .required(),
  });
  const formik = useFormik({
    initialValues: {
      type: 'work',
      additional_info: '',
      number: '',
    },
    validationSchema: formSchema,
    onSubmit: (data: phoneTypes) => {
      onClose();
      parentFormik?.setFieldValue('phones', [...phonesData, data]);
      resetForm();
    },
  });
  const { errors, isValid, resetForm } = formik;

  const deletePhones = (index: number) => {
    const t = phonesData.filter((o: phoneTypes, i: number) => i !== index);

    parentFormik.values.phones = t;
    parentFormik.setFieldValue?.('phones ', t);
  };

  return (
    <div>
      {phonesData.length === 0 && !addPhones ? (
        <div style={{ marginLeft: '45%', marginTop: '10px', color: '#D1D1D1' }}>
          No item
        </div>
      ) : (
        phonesData.map((item: phoneTypes, index: number) => (
          <div
            key={index}
            style={{
              display: 'flex',
              width: '100%',
              gap: 10,
              marginTop: 15,
              paddingLeft: 10,
            }}
          >
            <div style={{ width: '30%' }}>
              <Select
                value={item.type}
                style={{
                  width: '100%',
                  height: 30,
                  border: '0.5px solid #73A1E7',
                }}
                open={false}
                // onChange={formik.handleChange}
                id="type"
                className="children_dependents_select"
              >
                {phonesChoice.map((item, index) => (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                ))}
              </Select>
            </div>
            <Input
              readOnly
              defaultValue={item.additional_info}
              style={{ width: '30%' }}
              className="add_user_input_table"
            />
            <Input
              readOnly
              defaultValue={item.number}
              value={item.number}
              style={{ width: '30%' }}
              className="add_user_input_table"
            />
            <div style={{ display: 'flex', padding: 5, gap: 10, width: '10%' }}>
              <div>
                <img
                  onClick={() => deletePhones(index)}
                  style={{ cursor: 'pointer', height: '20px', width: '20px' }}
                  src="/icons/decline.svg"
                  alt="decline"
                />
              </div>
            </div>
          </div>
        ))
      )}
      {addPhones && (
        <div>
          <form
            onSubmit={formik.handleSubmit}
            style={{
              display: 'flex',
              width: '100%',
              gap: 10,
              marginTop: 15,
              paddingLeft: 10,
            }}
          >
            <div style={{ width: '30%' }}>
              {/* <CustomDropdown defaultBorder='0px' height="30px" options={mrs} /> */}
              <select
                style={{
                  width: '100%',
                  height: 30,
                  border: '0.5px solid #73A1E7',
                  paddingLeft: '7px',
                  fontSize: '12px',
                  color: '#000',
                }}
                onChange={formik.handleChange}
                name="type"
                className="children_dependents_select"
              >
                {phonesChoice.map((item, index) => (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            <Input
              onChange={formik.handleChange}
              name="additional_info"
              style={{ width: '30%' }}
              className="add_user_input_table"
            />
            <Input
              type="tel"
              onChange={formik.handleChange}
              name="number"
              min={0}
              style={{
                width: '30%',
                borderColor: (errors?.number as string) ? 'red' : '',
              }}
              maxLength={20}
              className="add_user_input_table"
            />
            <div style={{ display: 'flex', padding: 5, gap: 10, width: '10%' }}>
              <div
                // disabled={isValid}
                onClick={() => formik.handleSubmit()}
                style={{ padding: 0, border: 'none', background: 'white' }}
              >
                <img
                  style={{ cursor: 'pointer', height: '20px', width: '20px' }}
                  src="/icons/accept.svg"
                  alt="accept"
                />
              </div>
              <div>
                <img
                  onClick={() => {
                    resetForm();
                    onClose();
                  }}
                  style={{ cursor: 'pointer', height: '20px', width: '20px' }}
                  src="/icons/decline.svg"
                  alt="decline"
                />
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default PhonesTable;
